import Api from '@/services/Api'

export default {

  // Método que llama a la url para crear un chat
  getPatientEmergencies () {
    return Api().get("/patient-emergencies");
  },
  updatePatientEmergency (params) {
    return Api().put("/patient-emergencies",params);
  },
  addPatientEmergency (params) {
    return Api().post("/patient-emergencies",params);
  },
  getPatientEmergency (params) {
    return Api().get("/patient-emergencies/"+params);
  },
  deletePatientEmergency (params) {
    return Api().delete("/patient-emergencies/"+params);
  },
  getPatientEmergencyByRouteSheets(params){
    return Api().get("/patient-emergencies-route-sheet/"+params);
  },

}



// WEBPACK FOOTER //
// ./src/services/PatientEmergencyService.js